import React from 'react';
import { NavLink } from 'react-router-dom';

import {
  Container,
  Content,
  HomeIcon,
  BuyIcon,
  BagIcon,
  CalendarIcon,
  DocumentIcon,
} from './styles';

const MenuProduction: React.FC = () => {
  return (
    <Container>
      <Content>
        <div className="topMenu" />
        <div className="menuBox">
          <div className="menuItem">
            <NavLink to="/production" activeClassName="selected">
              <HomeIcon size={20} />
              <div className="titleMenu">
                <h5>HOME</h5>
              </div>
            </NavLink>
          </div>

          <div className="menuItem">
            <NavLink to="/novo-pedido-producao" activeClassName="selected">
              <BuyIcon />
              <div className="titleMenu">
                <h5>NOVO PEDIDO</h5>
              </div>
            </NavLink>
          </div>
          <div className="menuItem">
            <NavLink to="/producao-do-dia-producao" activeClassName="selected">
              <BagIcon />
              <div className="titleMenu">
                <h5>PRODUÇÃO</h5>
              </div>
            </NavLink>
          </div>
          <div className="menuItem">
            <NavLink
              to="/entregas-pendentes-producao"
              activeClassName="selected"
            >
              <CalendarIcon />
              <div className="titleMenu">
                <h5>ENTREGAS</h5>
              </div>
            </NavLink>
          </div>
          <div className="menuItem">
            <NavLink to="/proximos-pedidos-producao" activeClassName="selected">
              <CalendarIcon />
              <div className="titleMenu">
                <h5>PROX PEDIDOS</h5>
              </div>
            </NavLink>
          </div>
          <div className="menuItem">
            <NavLink to="/historico-producao" activeClassName="selected">
              <DocumentIcon />
              <div className="titleMenu">
                <h5>HISTÓRICO</h5>
              </div>
            </NavLink>
          </div>
        </div>
      </Content>
    </Container>
  );
};

export default MenuProduction;
